import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './router/routes'
import { Provider } from "react-redux";
import store from "./redux/store";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './bootstrap/bootstrap-icons/bootstrap-icons.css'



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
